// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__5FrgF","col":"styles_col__BIFlN"};